import React from 'react'

import { BarChart3 } from 'lucide-react'

import { useIsMobile } from '@/shared/hooks/useIsMobile'

interface TxListSummaryProps {
  count: number
  hasMore: boolean
  filterLabel?: string
}

const TxListSummary: React.FC<TxListSummaryProps> = ({ count, hasMore, filterLabel }) => {
  const isMobile = useIsMobile()

  const filterSuffix = filterLabel ? ` · ${filterLabel}` : ''

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'var(--space-lg)',
        padding: isMobile ? 'var(--space-10) var(--space-14)' : 'var(--space-lg) var(--space-20)',
        borderBottom: '0.5px solid var(--app-hairline-subtle)',
        fontSize: isMobile ? 'var(--font-size-sm)' : 'var(--font-size-md)',
        color: 'var(--app-text-secondary)',
        backgroundColor: 'var(--app-card-bg)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-md)', minWidth: 0 }}>
        <BarChart3 size={isMobile ? 14 : 16} style={{ flexShrink: 0, opacity: 0.7 }} />
        <span style={{ lineHeight: 1.4 }}>
          Latest <strong style={{ color: 'var(--app-text-primary)', fontWeight: 600 }}>{count}</strong> transaction
          {count === 1 ? '' : 's'}
          {hasMore ? ' · More available' : ''}
          {filterSuffix}
        </span>
      </div>
    </div>
  )
}

export default TxListSummary
